/*
 * @Author: Ryan
 * @Date: 2025-12-02
 * @Description: Start button component with scroll-to-top default behavior
 */
import { Button, ButtonProps } from 'antd';
import React from 'react';

import { scrollToTop } from '@/utils/landing/scrollToTop';

export interface StartButtonProps extends Omit<ButtonProps, 'onClick'> {
  /**
   * 按钮文本
   */
  text?: string;
  /**
   * 自定义点击处理函数，如果提供则覆盖默认的滚动到顶部行为
   */
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const StartButton: React.FC<StartButtonProps> = ({
  text = 'Start Translating',
  onClick,
  className,
  ...restProps
}) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      scrollToTop();
    }
  };

  return (
    <Button
      type="primary"
      shape="round"
      size="large"
      onClick={handleClick}
      className={`!bg-[#3366FF] !border-[#3366FF] hover:!bg-[#3758c7] !h-[42px] !px-8 !text-base !font-medium ${className || ''}`}
      {...restProps}
    >
      {text}
    </Button>
  );
};

export default StartButton;
